<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
              <LazyHomeSubPagesPlatformSkillAdvance />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {LazyHomeSubPagesPlatformSkillAdvance} from "#components";
import {useSiteNavigationLd} from "~/composables/useSiteNavigationLd";
import {useSeoMeta} from "~/composables/useSeoMeta";

const { t } = useI18n();
const siteLinkScript = useSiteNavigationLd();
const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: t("seo.home.skillAdvance.title"),
  meta: [
    {
      name: 'description',
      content: t("seo.home.skillAdvance.meta.description")
    },
    {
      name: 'title',
      content: t("seo.home.skillAdvance.meta.title")
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ],
  script: [siteLinkScript],
  link: [
    ...getHreflangLinks.value,
    { rel: 'canonical', href: getCanonical.value }
  ]
})

definePageMeta({
  // 언어별 경로를 alias로 추가
  alias: [
    '/en/home/skillAdvance',
    '/ja/home/skillAdvance',
    '/ko/home/skillAdvance',
    '/vi/home/skillAdvance',
  ]
})
</script>